// extracted by mini-css-extract-plugin
export default {"list__flex":"List_list__flex__KZW2K"};